import React, { FC, useEffect, useMemo, useState } from 'react';
import Profile from './Profile';
import 'whatwg-fetch';
import useLegacyUser from 'src/hooks/api/useLegacyUser';
import { LegacyUser } from 'src/interfaces/api/User';
import { LegacyEmployee } from 'src/interfaces/api/Employee';
import { RankProvider } from './hooks/useRank';

interface Props {
  me?: LegacyUser;
  match: any;
}

type User = LegacyUser & {
  newCrmId?: string;
  typeUser: Omit<LegacyEmployee, 'user'>;
};

const ProfileContainer: FC<Props> = ({ me, ...props }) => {
  const { get } = useLegacyUser();

  const [user, setUser] = useState<User>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();

  const { id } = props.match.params;

  useEffect(() => {
    if (id) {
      setLoading(true);
      get(id)
        .then((user) => {
          setUser(user);
          setLoading(false);
        })
        .catch((error) => {
          setError(error.message || "Une erreur est survenue lors de la récupèration de l'utilisateur");
          setLoading(false);
        });
    }
  }, [id]);

  return (
    <RankProvider user={user}>
      <Profile
        isMe={useMemo(() => me && me.id === parseInt(id, 10), [me, id])}
        user={user}
        loading={loading}
        error={error}
      />
    </RankProvider>
  );
};

export default ProfileContainer;
